module.exports = __webpack_public_path__ + "03_short_brown.f75da3a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/03_short_brown.png
// module id = AS94
// module chunks = 0